import {FilterCriterionInput} from './filter-criterion-input';
import {QueryLangFilterCriterion} from './query-lang-filter-criterion';

export class QueryLangFilterCriterionInput<ITEM extends Record<string, any> = any>
    extends QueryLangFilterCriterion<ITEM>
    implements FilterCriterionInput {

    public name: string;
}
